export default __webpack_public_path__ + "static/media/item_3.18fde4d3.png";